import { render } from "./Ma_PageViewInfo.vue?vue&type=template&id=7fbdc5d0&scoped=true"
import script from "./Ma_PageViewInfo.vue?vue&type=script&lang=js"
export * from "./Ma_PageViewInfo.vue?vue&type=script&lang=js"

import "./Ma_PageViewInfo.vue?vue&type=style&index=0&id=7fbdc5d0&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fbdc5d0"]])

export default __exports__